/** Beyond this many documents a bundled download is not supported. */
// Today we put a limit of 50 documents for a bundled download. because the server is not able to handle more than 50 documents.
// In future we can increase this limit if the server is able to handle more than 150 documents.
// author: @chetandhiman-cd - frontend & backend - @rahulkumar
export const MAX_DOWNLOADABLE_DOCUMENTS = 80;

export const ORIGINAL_XEROX_OPTIONS = [
  {
    name: "Original",
    value: "original"
  },
  {
    name: "Xerox",
    value: "xerox"
  }
];
